import React from "react";
import { useTranslation } from "react-i18next";

const formatAddress = (info = {}) =>
	`${info.street || ""}, ${info.city || ""}, ${info.zipCode || ""}, ${info.country || ""}`
		.replace(/^(, )+|(, )+$/g, "")
		.trim();

const PanelSection = ({ title, fields }) => {
	const visible = fields.filter((f) => f.value);
	if (visible.length === 0) return null;
	return (
		<div className="lv-panel-section">
			<div className="lv-panel-section-title">{title}</div>
			{visible.map((f, i) => (
				<div key={i} className="lv-panel-field-row">
					<span className="lv-panel-field-label">{f.label}</span>
					<span className="lv-panel-field-value">{f.value}</span>
				</div>
			))}
		</div>
	);
};

const LvDetailsPanel = ({
	projectInfo = {},
	buyerInfo = {},
	serviceSpecifications = [],
}) => {
	const { t } = useTranslation();

	const biddersMap = new Map();
	serviceSpecifications?.forEach((spec) => {
		if (spec?.bidder?.id) {
			biddersMap.set(spec.bidder.id, spec.bidder);
		}
	});
	const uniqueBidders = Array.from(biddersMap.values());

	return (
		<>
			<PanelSection
				title={t("lv.project-info")}
				fields={[
					{ label: t("project-info-table.name"), value: projectInfo?.name },
					{
						label: t("project-info-table.description"),
						value: projectInfo?.descriptionShort,
					},
				]}
			/>

			<PanelSection
				title={t("lv.buyer-info")}
				fields={[
					{ label: t("buyer-info-table.name"), value: buyerInfo?.name },
					{ label: t("buyer-info-table.email"), value: buyerInfo?.email },
					{ label: t("buyer-info-table.phone"), value: buyerInfo?.phone },
					{
						label: t("buyer-info-table.address"),
						value: formatAddress(buyerInfo),
					},
				]}
			/>

			{uniqueBidders.map((bidder, idx) => (
				<PanelSection
					key={bidder.id || idx}
					title={
						uniqueBidders.length > 1
							? `${t("lv.bidder-info")} #${idx + 1}`
							: t("lv.bidder-info")
					}
					fields={[
						{ label: t("bidder-info-table.name"), value: bidder?.name },
						{ label: t("bidder-info-table.email"), value: bidder?.email },
						{ label: t("bidder-info-table.phone"), value: bidder?.phone },
						{
							label: t("bidder-info-table.address"),
							value: formatAddress(bidder),
						},
					]}
				/>
			))}
		</>
	);
};

export default LvDetailsPanel;
